<div class="modal-backdrop" [ngClass]="{'is-visible': isVisible, 'is-hidden': !isVisible}">
    <section class="confirmation-modal" [ngClass]="{'is-visible': isVisible, 'is-hidden': !isVisible}">
        <div class="modal-content">
            <div class="close-icon-wrapper">
                <img src="../../../../assets/iconClose.png" alt="" class="close-icon" (click)="closeModal()" />
            </div>
            <div class="modal-icon-wrapper">
                <img src="../../../../assets/iconUnlock.png" alt="" class="modal-icon" />
            </div>
            <p class="modal-text" *ngIf="confirmButtonText === 'Desbloquear'">
                El usuario podrá acceder nuevamente a su cuenta y a todas las funcionalidades.
            </p>
            <p class="modal-text" *ngIf="confirmationType === 'get-otp'">
                Se ha obtenido correctamente el codigo OTP del usuario
            </p>
            <p class="modal-text" *ngIf="confirmationType === 'first-login'">
                Se ha obtenido correctamente la url para el first login del usuario
            </p>
            <div class="confirmation-text-wrapper">
                <p class="confirmation-text">{{ confirmationText }}</p>
                <button class="copy-button" (click)="copyToClipboard()" title="Copiar"
                    *ngIf="confirmationType === 'get-otp' || confirmationType === 'first-login'">
                    <i class="material-icons">content_copy</i>
                </button>
            </div>

            <div class="button-group" *ngIf="confirmButtonText !== ''">
                <button class="cancel-button" (click)="onCancel()" *ngIf="showCancelButton">Cancelar</button>
                <button class="confirm-button" (click)="onConfirm()">{{confirmButtonText}}</button>
            </div>

            <!-- Mensaje de éxito -->
            <div *ngIf="copySuccess" class="copy-success">¡Texto copiado al portapapeles!</div>
        </div>
    </section>
</div>